"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTotalParticipant = getTotalParticipant;
exports.getTotalParticipantHike = getTotalParticipantHike;
var _request = _interopRequireDefault(require("@/utils/request"));
function getTotalParticipant(token, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/trainings/range',
    method: 'post',
    headers,
    data
  });
}
function getTotalParticipantHike(token, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/hikes/range',
    method: 'post',
    headers,
    data
  });
}